import { initializeApp, getApps } from "firebase/app";
import {
  initializeAuth,
  inMemoryPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// same config you already use
const firebaseConfig = {
  apiKey: "AIzaSyDWKpgkcNOGoY5PC0vL_2eDLERvdWqp3p0",
  authDomain: "integrity-resolutions-inc.firebaseapp.com",
  projectId: "integrity-resolutions-inc",
  storageBucket: "integrity-resolutions-inc.firebasestorage.app",
  messagingSenderId: "774073159618",
  appId: "1:774073159618:web:2e78b638ab75f7293d905b",
  measurementId: "G-9E0N15FRDT",
  databaseId: "clientinformation"
};

// make a SECOND app specifically for portal (separate Auth instance)
const portalApp =
  getApps().find(a => a.name === "portal") ??
  initializeApp(firebaseConfig, "portal");

// memory-only auth so we never touch IndexedDB in the portal
const authPortal = initializeAuth(portalApp, {
  persistence: [inMemoryPersistence],
});

// keep your named Firestore DB
const dbPortal = getFirestore(portalApp, firebaseConfig.databaseId);
const functionsPortal = getFunctions(portalApp, "us-central1");
const storagePortal = getStorage(portalApp);

export { portalApp, authPortal, dbPortal, functionsPortal, storagePortal };